import { useAuth } from 'app/context';
import { ROUTES } from 'app/utils';
import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

export const PermissionRedirect = () => {
  // const { loggedUser } = useAuth();

  // if (loggedUser) {
  //   if (loggedUser) {
  //     return <Navigate to={ROUTES.users} />;
  //   }
  //   return <Typography>No permission found</Typography>;
  // } else {
  return <Navigate to={ROUTES.login} />;
  // }
};

interface ProtectedRouteProps {
  permissions: string[];
  children: ReactElement;
}

export const ProtectedRoute = ({ permissions, children }: ProtectedRouteProps): ReactElement | null => {
  const { access_token, loggedUser } = useAuth();

  let allow = access_token !== undefined;

  if (loggedUser !== undefined) {
    permissions.forEach((el) => {
      if (allow) {
        allow = (allow && loggedUser?.role === el) ?? false;
      }
    });
  }

  if (allow) {
    return children;
  } else {
    return <PermissionRedirect />;
  }
};
